import { Text } from "@ds/react";
import * as S from "./DetailsSection.style";

const DetailsSection = () => {
  return (
    <>
      <S.Container>
        <Text variant="caption-02" as="p">
          <strong>Título de Capitalização, modalidade Popular</strong>,
          emitido pela CNP CAPITALIZACAO S.A., CNPJ nº 01.599.296/0001-71,
          Processo SUSEP nº 15414.613991/2022-14. É proibida a venda de título
          de capitalização a menores de 16 anos - Art. 3º, I, do Código Civil.
          O valor de resgate, somente estará disponível ao Titular após 12 meses do
          início de vigência, exceto se houver a liquidação antecipada, mediante
          contemplação por sorteio. Se os valores não forem resgatados dentro do prazo
          prescricional, o titular do direito de resgate perderá esse direito.
          Ao final do plano, direito de 50% do valor pago no título.
          Antes de contratar, consulte previamente as condições contratuais do
          título de capitalização no site{" "}
          <a href="www.capvencedor.com.br" target="_blank" rel="noreferrer">
            www.capvencedor.com.br
          </a>
          , que também poderão ser consultadas no endereço{" "}
          <a href="https://www.susep.gov.br" target="_blank" rel="noreferrer">
            www.susep.gov.br
          </a>
          . O registro do produto é automático e não representa aprovação ou recomendação
          por parte da SUSEP. Nos termos da Resolução CNSP 382/2020, a CNP Capitalização S.A
          informa que remunera seus intermediários em 11% pela comercialização do título Cap
          Vencedor. Ouvidoria <a href="tel:0800 272 2022"> 0800 272 2022</a>, de
          segunda a sexta, das 8h às 18h, exceto feriados nacionais.
        </Text>
      </S.Container>
      <div>
        <S.Container>
          <Text variant="caption-02">
            CNP Capitalização S/A - CNPJ nº 01.599.296/0001-71<br></br>
            Endereço: Avenida Tamboré, nº 267, Torre Norte, 14º andar, parte, CEP 06460-000, Barueri/SP
          </Text>
        </S.Container>
        <S.Container>
          <Text variant="caption-02">
            <p><strong>A CNP Seguradora reúne empresas de Seguros</strong>  (CNPJ 92.751.213/0001-73 - Companhia de Seguros Previdência do Sul - Previsul - Ed. Berrini One, Av. Engenheiro Luís Carlos Berrini, nº 105, 7º andar, Cidade Monções, São Paulo/SP - CEP: 04571-900),<strong>  Odonto</strong>  (CNPJ 40.223.893/0001-59 - Odonto Empresas Convênios Dentários LTDA - Av. Tamboré, nº 267, Torre Norte, 15º andar, Tamboré, Barueri/SP - CEP: 06460-000) e <strong> Capitalização </strong> (CNPJ 01.599.296/0001-71 - CNP Capitalização S.A. - Av. Tamboré, nº 267, Torre Norte, 14º andar, parte, Tamboré, Barueri/SP - CEP: 06460-000).</p>
          </Text>
        </S.Container>
        <S.Container className="copyright">
          <Text variant="caption-02">© Copyright 2023 Cap Vencedor</Text>
        </S.Container>
      </div>
    </>
  );
};

export default DetailsSection;
